export default __webpack_public_path__ + "static/media/brand-4.8a2e7979.png";